import { Injectable } from '@angular/core'
import { Observable, from } from 'rxjs'
import { BuilderService } from 'src/app/builder-services/builder.service'
import { DiscountsApiService } from 'src/app/builder-services/api/discounts.api.service'

@Injectable({
  providedIn: 'root'
})
export class DiscountService {
  get project_id() { return this.builderService.selectedProject }

  constructor(
    private builderService: BuilderService,
    private discountsApi: DiscountsApiService,
  ) {}

  submitDiscount(discount: any): Observable<string | null> {
    return from(this.discountsApi.insertDiscount(String(this.project_id), discount))
  }

  getDiscounts(): Observable<any[]> {
    return from(this.discountsApi.getDiscounts(this.project_id))
  }

  deleteDiscount(discountId: string): Observable<void> {
    return from(this.discountsApi.deleteDiscount(String(this.project_id), discountId))
  }

  getDiscount(discountId: string): Observable<any> {
    return from(this.discountsApi.getDiscount(this.project_id, discountId))
  }

  updateDiscount(id: string, discount: any): Observable<void> {
    return from(this.discountsApi.updateDiscount(String(this.project_id), id, discount))
  }
}
